import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import night_mode_gen_2 from '@devices/settings/device_settings/night_mode_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import safety_gen_2_under_voltage from '@devices/settings/device_settings/safety_gen_2_under_voltage.js';
import app_setting_plus_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_plus_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import pro_dimmer_settings_g2_0110 from '@devices/settings/device_settings/pro_dimmer_settings_g2_0110.js';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';
import addon_sensors, { addon_pro_devices } from '@devices/settings/device_settings/addon_sensors';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyPro0110PM',
	friendly_name: 'Pro Dimmer 0/1-10V PM',
	family: 'light',
	isPM: true,
	addons: addon_pro_devices,
	reset_from_input: true,
	modes: {
		light: {
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'forgotten_lights',
				'overvoltage',
				'overtemperature',
			],
			color_temp: false,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				night_mode_gen_2,
				addon_sensors,
				virtual_components,
				scripts_gen_2,
				networks_gen_2_pro,
				bluetooth_bt_home_control_gen_2,
				safety_gen_2_under_voltage,
				app_setting_plus_rgbw_gen_2,
				share,
				pro_dimmer_settings_g2_0110,
			],
		},
	},
};
